import {
	GEOLOCATION,
	SHOW_INTERSTITIAL,
	HIDE_INTERSTITIAL,
	SAVE_AD_SLOT,
	DELETE_AD_SLOT,
	SHOW_AD_SLOT,
	HIDE_AD_SLOT,
	ADS_PERMISSIONS,
	RESET_HIDDEN_ADS,
	SET_GPTCORRELATOR,
	DOCUMENT_VISIBLE
} from 'Actions/adsActions';

import { UPDATE_PAGE_NUMBER } from 'Actions/InfiniteScrollActions';

const initialState = {
	geoLocation: {
		allow: true,
		error: false,
		latitude: '',
		longitude: '',
		timestamp: 0
	},
	adSlots: [],
	showInterstitial: false,
	noAdsPermissions: false,
	secondaryAds: false,
	resetHiddenAds: 0,
	documentVisible: false,
	analytics: 0
};

export function ads(state = initialState, action) {
	let adSlots;

	switch (action.type) {
		case GEOLOCATION:
			return Object.assign( {}, state, { geoLocation: action.location } );

		case SHOW_INTERSTITIAL:
			return {
				...state,
				showInterstitial: true
			};

		case HIDE_INTERSTITIAL:
			return {
				...state,
				showInterstitial: false
			};

		case SAVE_AD_SLOT:
			adSlots = Object.assign( {}, state.adSlots );
			adSlots[ action.slotName ] = false; // by default is hidden

			return Object.assign( {}, state, { adSlots: adSlots } );

		case DELETE_AD_SLOT:
			adSlots = Object.assign( {}, state.adSlots );
			delete adSlots[ action.slotName ];

			return Object.assign( {}, state, { adSlots: adSlots } );

		case SHOW_AD_SLOT:
			adSlots = Object.assign( {}, state.adSlots );
			adSlots[ action.slotName ] = true;

			return Object.assign( {}, state, { adSlots: adSlots } );

		case HIDE_AD_SLOT:
			adSlots = Object.assign( {}, state.adSlots );
			adSlots[ action.slotName ] = false;

			return Object.assign( {}, state, { adSlots: adSlots } );

		case ADS_PERMISSIONS:
			return {
				...state,
				noAdsPermissions: typeof action.values.noAdsPermissions !== 'undefined' ? action.values.noAdsPermissions : state.noAdsPermissions,
				secondaryAds: typeof action.values.secondaryAds !== 'undefined' ? action.values.secondaryAds : state.secondaryAds
			};

		case RESET_HIDDEN_ADS:
			return {
				...state,
				resetHiddenAds: new Date().getTime()
			};

		case SET_GPTCORRELATOR:
			return {
				...state,
				changeGPTCorrelator: action.refresh
			};

		case DOCUMENT_VISIBLE:
			return {
				...state,
				documentVisible: action.visible
			};

		case UPDATE_PAGE_NUMBER:
		case '@@router/LOCATION_CHANGE': // We use this to trigger location change events
			return {
				...state,
				analytics: new Date().getTime()
			};

		default :
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/ads.js